// Utilities
import {$} from '../../utilities/selector';

// Components
// import modals from './';
import Modal from './modal-base'

class ModalManager {
  constructor() {
    this.modalEls = [...$('[data-modal]')];
    this.modals = {};
    this.triggers = {
      open: [...$('[data-js~=modal-open]')],
      close: [...$('[data-js~=modal-close]')]
    };
    if ( this.modalEls.length )
      this.init();

  }

  init() {
    this.modalEls.map(el => this.create(el));
    this.bind();
    //return this;
  }

  create(el) {
    // let type = el.getAttribute('data-type');
    this.modals[el.getAttribute('data-modal')] = new Modal(el);
  }

  bind() {
    console.log(this.triggers);
    this.triggers.open.map(el => {
      el.addEventListener('click', e => this.open(e));
    });

    this.triggers.close.map(el => {
      el.addEventListener('click', e => this.close());
    });

    window.addEventListener('keyup', e => {
      if ( e.keyCode == 27 )
        this.close();
    });
  }

  open(e) {
    this.close();
    document.body.classList.add('has-modal');
    this.modals[e.currentTarget.getAttribute('data-target')].open();
  }

  close() {
    document.body.classList.remove('has-modal');
    Object.keys(this.modals).map(modal => {
      this.modals[modal].close();
    });
  }
}

export default new ModalManager();



// WEBPACK FOOTER //
// ./scripts/components/modals/manager.js